import styled from 'styled-components';
import { Box } from '@user-portal/wikr-components';

export const Container = styled(Box)`
    ${({ $paddingBottom }) => $paddingBottom && `padding-bottom: ${$paddingBottom}px;`};
    ${({ $paddingTop }) => $paddingTop && `padding-top: ${$paddingTop}px;`};
    max-width: 100%;
`;
